import React from 'react';
import PropTypes from 'prop-types';

export const AccessibleEmoji = ({ emoji, emojiName }) => {
  return (
    <span aria-label={`${emojiName} emoji`} role='img'>
      {emoji}
    </span>
  );
};

AccessibleEmoji.propTypes = {
  emoji: PropTypes.string.isRequired,
  emojiName: PropTypes.string.isRequired,
};
